/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/Component/TestStepsControl" />
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";
import { ITfsPageService } from "Tfs/Platform/Page";
import { Table, TableColumnLayout, renderSimpleCell, ISimpleTableCell, SimpleTableCell, ITableColumn } from "VSSUI/Table";
import { Card } from "VSSUI/Card";
import { Link } from "VSSUI/Link";
import { ITooltipProps } from "VSSUI/TooltipEx";
import * as Utils_UI from "VSSUI/Util";
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import * as Utils_String from "VSS/Core/Util/String";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { DalFields } from "Wit/Common/Generated/Constants";
import { IField, IFieldSetValueOptions, IWorkItem, ILink } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { Attachment } from "Wit/WorkItemModel/WorkItem/Links";
import { HtmlEditor } from "Wit/HtmlEditor/Components/HtmlEditor";
import * as Resources from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/Resources";
import * as Constants from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/Constants";
import { TestAction, TestStep, TestActionTypes } from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/TestStepsUtils/TestStepOM";
import { TestStepsParseUtils } from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/TestStepsUtils/TestStepsParseUtils";

interface ITestStepsControlProps extends IVssComponentProperties {
    workItem: IWorkItem;
}

export class TestStepsControl extends VssComponent<ITestStepsControlProps, IVssComponentContext> {
    private _pageContext: IVssPageContext;
    private _domParser: DOMParser = new DOMParser();
    private _stepsValue: string;
    private _stepTableColumns: ITableColumn<any>[];
    private _parameters: any;
    private _attachments: ILink[];
    private _workItem: IWorkItem;

    //State
    private _steps: ObservableArray<TestAction>;

    constructor(props: ITestStepsControlProps, context: IVssComponentContext) {
        super(props);
        this._pageContext = context.pageContext;
        this._stepTableColumns = this._getStepTableColumns();
        this._workItem = this.props.workItem;
        this._refreshState();
    }

    // Based on code in Tfs\Service\WebAccess\TestManagement\Scripts\TFS.TestManagement.Controls.ts:TestStepsControl:invalidate()
    private _refreshState() {
        if (this._workItem) {
            this._stepsValue = this._workItem.getFieldValueByName(Constants.TestStepsFieldName);

            let $stepsXml = this._domParser.parseFromString(this._stepsValue, "application/xml"),
                $steps,
                i,
                links,
                link;

            this._steps = new ObservableArray<TestAction>();
            this._parameters = [];
            this._attachments = [];

            //find the attachments
            links = this._workItem.getLinks();
            for (i = 0; i < links.length; i++) {
                link = links[i];

                if (link.linkData.FldID === DalFields.AttachedFiles || link instanceof Attachment) {
                    this._attachments.push(link);
                }
            }

            let stepsNodeList = $stepsXml.querySelectorAll("steps");
            let stepsCollection = $stepsXml.getElementsByTagName("steps");
            this.readSteps(stepsNodeList, this, true, true);

            /*$steps = $stepsXml.find("steps");
            this.readSteps($steps, this, true);

            $steps.remove();
            $stepsXml.remove();

            //load the shared test steps
            Diag.logTracePoint("TestStepsControl.loadSteps.start");
            this._fetch(this._steps, delegate(this, this._onStepsLoaded));
            */
        }
    }

    // Based on code in Tfs\Service\WebAccess\TestManagement\Scripts\TFS.TestManagement.Controls.ts:TestStepsControl:readSteps()
    public readSteps(steps: NodeListOf<Element> /*HTMLCollectionOf<Element>*/, stepsControl: any, reset?: boolean, shouldNewStepRow?: boolean) {
        let i; // lastRowText, lastRow;
        // if steps are to be read in case of this._stepsXmlDom modification
        // we must empty the datasource. Else , if it is a recursive call from
        // readSharedSteps, previous values must be preserved.
        if (reset) {
            this._steps.removeAll();
        }

        var testSteps: TestAction[] = TestStepsParseUtils.parseTestSteps(steps); //TMOM.TestBase.parseTestSteps(steps);
        for (var index = 0; index < testSteps.length; index++) {
            this._steps.push(testSteps[index]);
        }

        //TODO: this.testCase.setTestSteps(this._steps);

        for (var index = 0; index < this._steps.length; index++) {
            // TODO: if (!this._steps.value[index].ref)
            {
                (this._steps.value[index] as TestStep).processTestAttachments(stepsControl._attachments);
            }
        }

        /*
        // finally add an extra row that should not be an actual step.
        // This row should never get saved as a workitem step.
        // This row should only be used to trigger a click to add another row.
        if (shouldNewStepRow) {
            this._steps.push(this._stepsList._getaddNewStepRow());
        }
        // Content should be localized
        if (reset) {
            //set index for each step except the last one.
            if (this._steps && this._steps.length > 0) {
                for (i = 0; i < this._steps.length; i++) {
                    this._steps[i].setIndex(i + 1);
                }
            }
        }*/
    }

    public render(): JSX.Element {
        return (
            <div className="test-steps-control">
                NWP Test Steps Control
                <Card className="teststeps-table-card bolt-table-card" contentProps={{ contentPadding: false }}>
                    <Table
                        ariaLabel="Test Steps Table"
                        className="teststeps-table" //TODO
                        containerClassName="custom-scrollbar" //TODO
                        columns={this._stepTableColumns}
                        //eventDispatch
                        itemProvider={this._steps}
                        role="table"
                        scrollable={true}
                        showLines={false}
                        virtualize={false}
                    />
                </Card>
            </div>
        );
    }

    private _getStepTableColumns(): ITableColumn<any>[] {
        const tableColumns: ITableColumn<any>[] = [];

        tableColumns.push(
            {
                //columnLayout: TableColumnLayout.singleLinePrefix,
                id: "id",
                name: "Steps",
                readonly: true,
                renderCell: renderSimpleCell,
                width: new ObservableValue(40)
            },
            {
                //columnLayout: TableColumnLayout.none,
                id: "action",
                name: "Action",
                readonly: false,
                renderCell: this.renderActionColumn,
                width: new ObservableValue(500)
            },
            {
                //columnLayout: TableColumnLayout.none,
                id: "expected",
                name: "Expected Result",
                readonly: false,
                renderCell: this.renderExpectedColumn,
                width: new ObservableValue(300)
            },
            {
                //columnLayout: TableColumnLayout.none,
                id: "attachment",
                name: "Attachments",
                readonly: false,
                renderCell: (rowIndex, columnIndex, tableColumn, tableItem) =>
                    this.renderAttachmentColumn(rowIndex, columnIndex, tableColumn, tableItem),
                width: new ObservableValue(200)
            }
        );

        return tableColumns;
    }

    private renderActionColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: TestAction): JSX.Element {
        var multilineObservable = new ObservableValue<string>(tableItem.action);
        return (
            <td>
                <HtmlEditor
                    htmlContent={multilineObservable.value}
                    ariaLabel="Input text field"
                    className="flex-grow"
                    onChange={(newValue) => (multilineObservable.value = newValue)}
                />
            </td>
        );
    }

    private renderExpectedColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: TestAction): JSX.Element {
        if (tableItem.actionType !== TestActionTypes.Step) {
            return <SimpleTableCell columnIndex={columnIndex} />;
        }
        var stepTableItem: TestStep = tableItem as TestStep;
        var multilineObservable = new ObservableValue<string>(stepTableItem.expectedResult);
        return (
            <td>
                <HtmlEditor
                    htmlContent={multilineObservable.value}
                    ariaLabel="Input text field"
                    className="flex-grow"
                    onChange={(newValue) => (multilineObservable.value = newValue)}
                />
            </td>
        );
    }

    private renderAttachmentColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: TestAction): JSX.Element {
        var testStep: TestStep = tableItem as TestStep;
        var stepAttachments: Attachment[] = testStep.getAttachments();
        var attachmentRows: JSX.Element[] = [];

        for (var i = 0; i < stepAttachments.length; i++) {
            var attachment = stepAttachments[i];
            var attachmentSizeText = Utils_String.format(Resources.TestStepAttachmentSizeFormat, Math.ceil(attachment.linkData.Length ?? 0 / 1024));
            var attachmentText = Utils_String.format("{0} {1}", attachment.linkData.OriginalName ?? "", attachmentSizeText);

            var attachmentLinkToolTipProps: ITooltipProps = { overflowOnly: true, text: attachmentText };
            var attachmentUri = ""; // TODO: attachment.getLinkUrl(this._pageContext, this._getProjectName()).then()
            var attachmentLink = (
                <Link
                    className="attachment-column-text"
                    href={attachmentUri}
                    target="_blank"
                    rel="opener"
                    //onClick={(e) => this._onAttachmentClick(e, attachment)}
                    tooltipProps={attachmentLinkToolTipProps}
                >
                    {attachmentText}
                </Link>
            );

            var deleteAttachmentArgs = { attachment: attachment, testStep: testStep };
            var deleteIcon = (
                <Link
                    className="bowtie-icon bowtie-edit-delete attachment-delete-icon"
                    //TODO: ariaLabel={WITResources.DeleteAttachment}
                    onClick={(e) => this._onAttachmentDeleteClick(e, deleteAttachmentArgs)}
                    //TODO: tooltipProps={{ overflowOnly: true, text: WITResources.DeleteAttachment }}
                ></Link>
            );

            // if ($deleteIcon) {
            //     attachmentColumnWidth = attachmentColumnWidth - 24;
            // }

            var attachmentRow = (
                <tr key={attachment.linkData.FilePath}>
                    <td>{attachmentLink}</td>
                    {!this._isReadOnly() && <td>{deleteIcon}</td>}
                </tr>
            );

            attachmentRows.push(attachmentRow);
        }

        return (
            <td>
                <table className="attachment-content">{attachmentRows}</table>
            </td>
        );
    }

    private async _fetchAttachmentUri(attachment: Attachment) {
        return await attachment.getLinkUrl(this._pageContext, this._getProjectName());
    }

    private _onAttachmentDeleteClick(e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.KeyboardEvent<HTMLAnchorElement>, args: any): void {
        // TODO: Get this working
        // if ((e.type === "keydown" && e.which === Utils_UI.KeyCode.ENTER) ||
        //     e.type === "click") {
        //     let testStep: TMOM.TestStep = args.testStep,
        //         attachment: WITOM.Attachment = args.attachment,
        //         rowInfo: any,
        //         isItemRemoved: boolean;
        //     if (testStep && attachment) {
        //         isItemRemoved = testStep.deleteAttachment(attachment);
        //     }
        //     if (isItemRemoved) {
        //         rowInfo = this._getRowInfoFromEvent(e, ".grid-row");
        //         if (rowInfo) {
        //             this._updateRow(rowInfo, rowInfo.rowIndex, rowInfo.dataIndex, null, null);
        //         }
        //         this._focusSelectedElement();
        //     }
        // } else if (e.type === "keydown" && e.which === Utils_UI.KeyCode.TAB) {
        //     this._onCellTabKey(e);
        // }
    }

    private _isReadOnly() {
        return false;
        // TODO
        // if (typeof this._readOnlyDelegate !== "function"){
        //     return false;
        // }
        // return this._readOnlyDelegate();
    }

    private _getProjectName(): string {
        const tfsPageService = this._pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        let projectName = "";
        if (!tfsPageData || !tfsPageData.project) {
            throw new Error("Project missing");
        } else {
            projectName = tfsPageData.project.name;
        }
        return projectName;
    }
}
